module.exports = __webpack_public_path__ + "img/Body D.133d8c2a.png";